import { render } from "./Sedan.vue?vue&type=template&id=556c413e"
import script from "./Sedan.vue?vue&type=script&lang=js"
export * from "./Sedan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Sedan.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "556c413e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('556c413e', __exports__)) {
    api.reload('556c413e', __exports__)
  }
  
  module.hot.accept("./Sedan.vue?vue&type=template&id=556c413e", () => {
    api.rerender('556c413e', render)
  })

}


export default __exports__